import Module from '../../utils/modules/Module';
import EventsManager from "../../utils/events/EventsManager";
import CustomEvents from "../../utils/events/CustomEvents";
import Datepicker from "../../utils/forms/Datepicker";

export default class FiltersModule extends Module {

  constructor(options) {
    super(options);

    this.DOMEl = this.options.element;
    this.urlChanged = false;
    this.dateFields = ['dates', 'date', 'event_dates'];
    this.searchTimeout = null;

    this.searchContainer = this.DOMEl.closest('.search-container');
    this.filtersContainer = this.searchContainer.querySelector('.filters-container');
    this.currentContentContainer = null;

    // open & close filter modal window.
    document.querySelector('body').addEventListener('click', (ev) => {
      if (ev.target.matches('.btn-filters-close')) {
        this.onFiltersCloseClick(ev);
      }

      if (ev.target.matches('.btn-filters-open')) {
        this.onFiltersOpenClick(ev);
      }
    });

    document.querySelector('.btn-last').addEventListener('focusout', () => {
      document.querySelector('.filters-header .btn-filters-close').focus();
    });

    // Public methods.
    this.bindFiltersEvents = this.bindFiltersEvents.bind(this);
    this.submitFiltersSearchMain = this.submitFiltersSearchMain.bind(this);
    this.updateFilters = this.updateFilters.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onSearchKeydown = this.onSearchKeydown.bind(this);
    this.onSearchClean = this.onSearchClean.bind(this);
    this.onFilteredSearchSubmit = this.onFilteredSearchSubmit.bind(this);
    this.buildUrlQuery = this.buildUrlQuery.bind(this);
    this.clearSelection = this.clearSelection.bind(this);

    document.querySelectorAll('.clear-selection').forEach((clear) => {
      clear.addEventListener('click', (ev) => {
        this.clearSelection(ev);
      });
    });

    EventsManager.on(CustomEvents.search.SUBMIT_FILTERS, this.submitFiltersSearchMain);

    EventsManager.on(CustomEvents.search.UPDATE_FILTERS, this.updateFilters);

    EventsManager.on(CustomEvents.search.UPDATE_FILTERS, this.setHeight);

    // Entry point.
    if (this.filtersContainer !== null) {
      this.init(this.filtersContainer);
    }

    this.initSearchField(this.searchContainer);

    this.initSortBy(this.searchContainer);

    if (document.querySelector('.datepicker')) {
      this.datepicker = new Datepicker();
    }
  }

  init($container) {
    setTimeout(function () {
      $container.querySelectorAll('.sub-filters a, .sub-filters button, .sub-filter input').forEach(el => {
        el.setAttribute('tabindex', '-1');
      });
    }, 500);

    this.bindFiltersEvents($container);

    this.setHeight();

    this.toggleResearchProjectsButton();
  }

  initSearchField($searchContainer) {
    const $filteredSearch = $searchContainer.querySelector('form.filters:not(.global-search-form)');

    const $searchInput = $searchContainer.querySelector('input[name=q]');

    if ($searchInput !== null) {
      $searchInput.addEventListener('keydown', this.onSearchKeydown);

      $searchInput.addEventListener('input', this.onSearchChange);
    }

    if ($filteredSearch !== null) {
      $filteredSearch.addEventListener('submit', this.onFilteredSearchSubmit);
    }
  }

  initSortBy($searchContainer) {
    if ($searchContainer.querySelector('input[name="sort-by"]')) {
      $searchContainer.addEventListener('change', (ev) => {
        if (ev.target.matches('input[name="sort-by"]')) {
          const $form = $searchContainer.querySelector('form.filters');

          if ($form !== null) {
            $form.dispatchEvent(new Event('submit'));
          }
        }
      });
    }
  }

  /** ------------------------------
   * Events
   --------------------------------- */
  onFiltersCloseClick(ev) {
    ev.preventDefault();

    document.querySelector('.filters-search-wrapper').classList.add('close');

    setTimeout(function () {
      document.querySelector('.filters-search-wrapper').classList.add('hide');
    }, 655);
  }

  onFiltersOpenClick(ev) {
    ev.preventDefault();

    document.querySelector('.filters-search-wrapper').classList.remove('hide');

    setTimeout(function () {
      document.querySelector('.filters-search-wrapper').classList.remove('close');
    }, 10);

    document.querySelector('.filters-header .btn-filters-close').focus();
  }

  onKeywordClick(event) {
    // Prevent default behaviour on the button element.
    event.preventDefault();

    const label = document.querySelector('form.filters label[for="q"]');
    const input = document.querySelector('form.filters input[name="q"]');

    // Set the appropriate class on the label.
    label.setAttribute('class', 'labelUp');

    // Set the search query to the content of the keyword button.
    input.setAttribute('value', event.target.innerHTML);

    // Execute the search with the appropriate keyword.
    this.executeSearch(input);
  }

  // Used to open or close the filter group
  onToggleFilter(event) {
    event.preventDefault();

    let $thisButton = event.target;

    let filteredByGroup = $thisButton.closest('.filters-group').getAttribute('data-vid');

    console.log(filteredByGroup);

    let $childFilters = $thisButton.parentNode.querySelectorAll('.sub-filters[data-vid="' + filteredByGroup + '"]');

    let $otherFilters = $thisButton.parentNode.parentNode.querySelectorAll('.sub-filters:not([data-vid="' + filteredByGroup + '"],[data-vid="content_type"],[data-vid="resource_status"])');


    if ($childFilters.length > 0) {
      if ($thisButton.classList.contains('is-active')) {
        $thisButton.classList.remove('is-active');

        $childFilters.forEach(element => {
          element.classList.remove('is-active');

          element.setAttribute('aria-expanded', 'false');

          // Animation.
          element.querySelector('.wrapper').style.height = '0';

          let innerHeight = element.querySelector('.filter-content').clientHeight;

          this.setHeight(-innerHeight);
        });
      }
      else {
          //close every other filter group
          $otherFilters.forEach(element => {
            if (element.parentNode.querySelector('.btn-toggle') != null) {
              element.parentNode.querySelector('.btn-toggle').classList.remove('is-active');
            }

            element.classList.remove('is-active');

            element.setAttribute('aria-expanded', 'false');

            // Animation.
            if (element.querySelector('.wrapper') !== null) {
              element.querySelector('.wrapper').style.height = '0';
            }

            if (element.querySelector('.filter-content') !== null) {
              let innerHeight = element.querySelector('.filter-content').clientHeight;

              this.setHeight(-innerHeight);
            }
          });

        $thisButton.classList.add('is-active');

        $childFilters.forEach($childFilter => {
          // Uncheck all child if any of.
          if ($childFilter.querySelector('input:checked')) {
            $childFilter.querySelectorAll('li.is-disabled').forEach(el => el.classList.remove('is-disabled'));
          }

          $childFilter.setAttribute('aria-expanded', 'true');
          let $clearSelection = $childFilter.querySelector('.clear-selection');
          let $filterSelected = $childFilter.querySelector('.selected-filter');
          let $otherFilters = $childFilter.querySelector('.other-filter');
          if ($childFilter.parentNode.getAttribute('data-count') > 0) {
            if($clearSelection) {
              $clearSelection.style.display = "block";
            }
            if($filterSelected) {
              $filterSelected.style.display = "block";
            }
            if($otherFilters) {
              $otherFilters.style.display = "block";
            }
          }

          // Animation.
          const innerHeight = $childFilter.querySelector('.filter-content').clientHeight;

          if (innerHeight < 500) {
          $childFilter.querySelector('.wrapper').style.height = innerHeight + 'px';
        } else {
          $childFilter.querySelector('.wrapper').style.height = '500px';
        }

          this.setHeight(innerHeight);
        });

        setTimeout(() => this.handleFiltersPanelPosition($childFilters), 100);
      }
    }
  }

  // Resets the filters for the current opened panel
  onResetFilters(event) {
    event.preventDefault();

    let parent = event.target.closest('.sub-filters');

    let filterContainer = document.querySelector('.filters-container');

    let searchNeeded = false;

    if (parent === null) {
      // Clear search-bar
      let $searchInput = document.querySelector('#q');

      if ($searchInput.value.length > 0) {
        searchNeeded = true;

        $searchInput.value = '';
      }

      // Choose all content types.
      let $contentTypeAll = document.querySelector('#filter-content_type_all-');

      if ($contentTypeAll && !$contentTypeAll.checked) {
        $contentTypeAll.checked = true;

        searchNeeded = true;
      }

      // Reset inputs.
      let $items = document.querySelectorAll('.sub-filters input[type="checkbox"]:checked');

      $items.forEach(function ($this) {
        searchNeeded = true;

        $this.checked = false;
      });

      // Reset date.
      let datePickerToReset = [];

      let $dateSubFilters = filterContainer.querySelectorAll('.sub-filters[data-type="dates"]');

      $dateSubFilters.forEach(function (subFilters) {
        datePickerToReset.push(subFilters.getAttribute('id'));

        let dateInput = subFilters.querySelector('input.datepicker');

        if (dateInput.value !== '') {
          searchNeeded = true;

          dateInput.value = '';
        }
      });

      if (datePickerToReset) {
        for (let idSubFilters in datePickerToReset) {
          let picker = this.datepicker.datePickers[datePickerToReset[idSubFilters]];

          if (typeof (picker) !== 'undefined') {
            picker.clearSelection();
          }
        }
      }

      // Reset filters count to zero and trigger search
      if (searchNeeded) {
        let filtersGroups = Array.from(filterContainer.querySelectorAll('li.filters-group'));

        filtersGroups.filter(el => window.getComputedStyle(el).display !== 'none').forEach($li => {
          let type = $li.getAttribute('data-type');

          if (type !== 'content_type') {
            let $filterCount = $li.querySelector('.filter-count');

            $li.setAttribute('data-selected-filters', '');

            $li.setAttribute('data-count', 0);

            let btnFilter = $li.querySelector('.btn-filter');

            let $clearSelection = $li.querySelector('.clear-selection');
            let $filterSelected = $li.querySelector('.selected-filter');
            let $otherFilters = $li.querySelector('.other-filter');

            if (btnFilter) {
              btnFilter.classList.remove('has-count');
              if($clearSelection) {
                $clearSelection.style.display = 'none';
              }
              if($filterSelected) {
                $filterSelected.style.display = 'none';
              }
              if($otherFilters) {
                $otherFilters.style.display = 'none';
              }
            }

            if ($filterCount) {
              $filterCount.classList.add('is-empty');
              if($clearSelection) {
                $clearSelection.style.display = 'block';
              }
              if($filterSelected) {
                $filterSelected.style.display = 'block';
              }
              if($otherFilters) {
                $otherFilters.style.display = 'block';
              }

              $filterCount.innerHTML = '';
            }
          }
        });

        const contentType = filterContainer.querySelector('.sub-filters[data-type="content_type"] input:checked');

        const event = new CustomEvent('change', {
          detail: {
            customTarget: contentType,
          },
        });

        // Trigger the search
        filterContainer.dispatchEvent(event);
      }
    }
    else {
      if (parent.getAttribute('data-type') === 'dates') {
        const picker = this.datepicker.datePickers[parent.getAttribute('id')];

        if (typeof picker !== 'undefined') {
          picker.clearSelection();
        }

        const dateInput = parent.querySelector('input.datepicker');

        if (dateInput) {
          dateInput.value = '';

          const event = new CustomEvent('change', {
            detail: {
              customTarget: dateInput,
            },
          });

          // Trigger the search.
          filterContainer.dispatchEvent(event);
        }
      }
    }
  }

  // Triggered when filter is activated (no more submit button)
  onSubmitFilters(event, isOrphanFilter) {
    event.preventDefault();

    let $thisFilter = event.detail !== undefined && event.detail.customTarget !== undefined ? event.detail.customTarget : event.target;

    let searchQuery = '*';

    let $thisForm = $thisFilter.closest('form.filters');

    let $subFilters = $thisFilter.closest('.sub-filters');

    let filteredBy;

    let filteredValue;

    let type = '';

    if (!isOrphanFilter) {
      type = $subFilters.getAttribute('data-type');

      filteredBy = $subFilters.getAttribute('data-vid');

      filteredValue = (type === 'dates') ? $subFilters.querySelector('input.datepicker').value : $thisFilter.value;

      let filteredByGroup = $thisForm.querySelector('.filters-group[data-vid="' + filteredBy + '"]');

      this.updateFilterCount(filteredByGroup, filteredValue);
    }
    else {
      filteredBy = $thisFilter.closest('.orphan-filters').getAttribute('data-vid');

      let $checkbox = $thisFilter.parentNode.querySelector('input[type="checkbox"]');

      if ($checkbox !== null) {
        $checkbox.checked = !$checkbox.checked;
      }
      else {
        if ($thisForm.querySelector('.filters-container.layout-flat') !== null) {
          const $filterContainer = $thisFilter.closest('.filters-container');

          $filterContainer.querySelectorAll('li .btn-filter').forEach(el => el.classList.remove('is-active', 'is-loading', 'is-disabled'));

          $filterContainer.querySelectorAll('li input[type="radio"]').forEach(el => el.checked = false);
        }
        else {
          $thisFilter.parentNode.parentNode.querySelectorAll('li .btn-filter').forEach(el => el.classList.remove('is-active', 'is-loading'));
        }

        let $radio = $thisFilter.parentNode.querySelector('input[type="radio"]');

        if ($radio !== null) {
          $radio.checked = true;
        }
      }

      $thisFilter.classList.add('is-loading');

      setTimeout(() => {
        $thisFilter.classList.remove('is-loading');
        $thisFilter.classList.toggle('is-active');
      }, 200);
    }

    let $currentContentSection = $thisFilter.closest('.search-block');

    let baseAlgoliaFilter = $currentContentSection.getAttribute('data-filter');

    let activeFilters = this.getFilters($thisForm);

    let algoliaFilter = this.buildFiltersQuery(activeFilters, baseAlgoliaFilter);

    $currentContentSection.getAttribute('data-filter-refined', algoliaFilter);

    let $searchInput = $thisForm.querySelector('input[name="q"]');

    if ($searchInput !== null) {
      document.querySelector('.filters input[name="page"]').value = '0';

      searchQuery = $searchInput.value;

      let queryString = this.getQuerystring($currentContentSection, activeFilters);

      this.pushHistoryQuerystringAndFormAction($currentContentSection, queryString);
    }

    this.currentContainer = $currentContentSection.querySelector('div.teasers-container');

    const eventParams = {
      searchQuery: searchQuery,
      filters: algoliaFilter,
      currentVid: filteredBy,
      $resultsContainer: this.currentContainer,
      $filterContainer: $currentContentSection.querySelector('.filters-container'),
      offset: 0,
    };

    EventsManager.broadcast(CustomEvents.search.SEARCH_WITH_FILTERS, eventParams);
  }

  /**
   * Special actions when pressing specific keys.
   *
   * @param event
   */
  onSearchKeydown(event) {
    // When ESC is pressed, clean search.
    if (event.keyCode === 27) {
      this.onSearchClean(event);
    }
  };

  /**
   * When focusing main search input.
   *
   * @param event
   */
  onSearchFocus(event) {
    let container = event.currentTarget.closest('.search-container');

    container.classList.add('is-focused');

    if (this.searchTimeout !== null) {
      clearTimeout(this.searchTimeout);
    }
  }

  /**
   * When blurring main search input.
   *
   * @param event
   */
  onSearchBlur(event) {
    let container = event.currentTarget.closest('.search-container');

    this.searchTimeout = setTimeout(() => {
      container.classList.remove('is-focused');
    }, 300);
  }

  onSearchChange(event) {
    let $this = event.currentTarget;

    let search = $this.value;

    let $container = $this.closest('.search-container');

    if (search.length >= 2) {
      $container.classList.add('is-searching');

      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        this.executeSearch($this);
      }, 500);
    }
    else if (search === '') {
      this.onSearchClean(event);
    }
  }

  /**
   * Reset keyword search.
   *
   * @param event
   */
  onSearchClean(event) {
    event.preventDefault();

    let $this = event.currentTarget;

    let $container = $this.closest('.search-container');

    let $input = $container.querySelector('input[name=q]');

    $input.value = '';

    $container.classList.remove('is-searching');

    this.executeSearch($this);
  }

  onFilteredSearchSubmit(event) {
    event.preventDefault();

    let $form = event.currentTarget;

    let $input = $form.querySelector('input[name="q"]');

    this.executeSearch($input);
  }

  scrollToResults() {
    const $resultsContainer = this.DOMEl.closest('.search-block').querySelector('.teasers-container');

    if ($resultsContainer !== null) {
      let offset = 30;

      if (screen.width >= 768) {
        offset = 60;
      }

      let resultsOffset = $resultsContainer.getBoundingClientRect().top - offset + window.scrollY;

      document.querySelector('html, body').scroll({
        top: resultsOffset,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  setHeight(innerHeight = 0) {
    setTimeout(function () {
      let pageSearch = document.querySelector('.page-search');

      if (pageSearch) {
        // base height.
        let filtersHeight = pageSearch.querySelector('.filters-list').clientHeight;

        // apply height.
        pageSearch.querySelector('.results-wrapper').style.minHeight = filtersHeight + innerHeight + 'px';
      }
    }, 100);
  }

  /** ------------------------------
   * Public methods
   --------------------------------- */
  bindFiltersEvents($container) {
    document.querySelectorAll('button.search-keywords-btn').forEach(element => {
      element.addEventListener('click', event => this.onKeywordClick(event));
    });

    $container.querySelectorAll('.btn-toggle').forEach(element => {
      element.addEventListener('click', event => this.onToggleFilter(event));
    });

    document.querySelectorAll('.search-container .btn-reset').forEach(element => {
      element.addEventListener('click', event => this.onResetFilters(event));
    });

    $container.querySelectorAll('.orphan-filter').forEach(element => {
      element.addEventListener('click', event => this.onSubmitFilters(event, true));
    });

    $container.addEventListener('change', (event) => {
      this.setHeight();

      let target = event.detail !== undefined && event.detail.customTarget !== undefined ? event.detail.customTarget : event.target;

      if (target && target.matches('.sub-filters input[type="checkbox"], .sub-filters input[type="radio"], .sub-filters input.datepicker')) {
        this.onSubmitFilters(event, false);
      }
    });
  }

  updateFilters({$container, facets, currentVid}) {
    // Reset all filters by default
    $container.querySelectorAll('.orphan-filters li.is-disabled.is, .sub-filters li.is-disabled').forEach(element => {
      element.classList.remove('is-disabled');
    });

    $container.querySelectorAll('.orphan-filters, .sub-filters').forEach($this => {
      const type = $this.getAttribute('data-type');
      const vid = $this.getAttribute('data-vid');

      if (type === 'dates' || vid === currentVid) {
        return;
      }

      if (typeof (facets[vid]) !== 'undefined') {
        $this.querySelectorAll('input').forEach($input => {
          const $li = $input.parentNode;

          if (facets[vid].hasOwnProperty($input.getAttribute('data-name'))) {
            $li.classList.remove('is-disabled');
          }
          else {
            $li.classList.add('is-disabled');
          }
        });
      }
      else {
        $this.querySelectorAll('li').forEach(li => li.classList.add('is-disabled'));
      }

      $this.querySelectorAll('ul > li > ul').forEach($ul => {
        const $parent = $ul.parentNode;

        if ($ul.querySelectorAll('li.is-disabled').length === $ul.querySelectorAll('li').length) {
          $parent.classList.add('is-disabled');
        }
      });
    });

    this.setHeight(0);
  }

  submitFiltersSearchMain($thisForm) {
    let $searchContainer = $thisForm.closest('.search-container');

    let $searchInput = $thisForm.querySelector('input[name=q]');

    let $currentContentSection = $searchContainer.closest('.search-block');

    let baseAlgoliaFilter = $currentContentSection.getAttribute('data-filter');

    let searchQuery = $searchInput.value;

    let activeFilters = this.getFilters($thisForm);

    let algoliaFilter = this.buildFiltersQuery(activeFilters, baseAlgoliaFilter);

    $currentContentSection.getAttribute('data-filter-refined', algoliaFilter);

    let page = parseInt($thisForm.querySelector('input[name="page"]').value);

    let queryString = this.getQuerystring($currentContentSection, activeFilters);

    this.pushHistoryQuerystringAndFormAction($currentContentSection, queryString);

    this.currentContainer = $currentContentSection.querySelector('.teasers-container');

    let $filtersContainer = $currentContentSection.querySelector('.filters-container');

    const eventParams = {
      searchQuery: searchQuery,
      filters: algoliaFilter,
      currentVid: null,
      $resultsContainer: this.currentContainer,
      $filterContainer: $filtersContainer,
      offset: page,
    };

    EventsManager.broadcast(CustomEvents.search.SEARCH_WITH_FILTERS, eventParams);
  }

  getQuerystring($container, activeFilters = null) {
    if (activeFilters === null) {
      activeFilters = this.getFilters($container.querySelector('form.filters'));
    }

    let queryString = [];

    // Add search term.
    let $searchInput = $container.querySelector('input[name=q]');

    if ($searchInput.length !== 0 && $searchInput.value.length > 0) {
      queryString.push('q=' + encodeURIComponent($searchInput.value));
    }

    // Add page number
    const pageInput = $container.querySelector('input[name=page]');

    if (pageInput.length !== 0 && pageInput.value !== '0') {
      queryString.push('page=' + pageInput.value);
    }

    // Add filters
    const filtersQuerystring = this.buildUrlQuery(activeFilters, true);

    if (filtersQuerystring.length !== 0) {
      queryString.push(filtersQuerystring);
    }

    const sortBy = document.querySelector('input[name="sort-by"]:checked');

    if (sortBy && sortBy.value !== '') {
      queryString.push('sort-by=' + sortBy.value);
    }

    if (queryString.length === 0) {
      return '';
    }

    return '?' + queryString.join('&');
  }

  pushHistoryQuerystringAndFormAction($container, queryString) {
    let action = '';

    const $searchForm = $container.querySelector('form.search-form');

    if ($searchForm !== null) {
      action = $searchForm.getAttribute('action');
    }

    if (queryString.length === 0) {
      queryString = '?';
    }

    queryString = action + queryString;

    if (!this.urlChanged) {
      history.pushState(null, '', queryString);

      this.urlChanged = true;
    }
    else {
      history.replaceState(null, '', queryString);
    }
  }

  /**
   * Called when keyword search is triggered.
   *
   * @param searchInput
   */
  executeSearch(searchInput) {
    const searchFilters = searchInput.closest('.search-container');

    searchFilters.querySelector('input[name=page]').value = '0';

    const filters = searchFilters.querySelector('form.filters');

    this.submitFiltersSearchMain(filters);
  }

  // Called by onChangeFilters to update the filter count
  // Get the current count and current filters
  // Use it to increment or decrement the count
  updateFilterCount($filteredByGroup, filteredValue) {
    let vid = $filteredByGroup.getAttribute('data-vid');

    let type = $filteredByGroup.getAttribute('data-type');

    let currentCount = 0;

    let currentFilters = $filteredByGroup.getAttribute('data-selected-filters');

    let $filterCount = $filteredByGroup.querySelector('.filter-count');

    let $clearSelection = $filteredByGroup.querySelector('.clear-selection');
    let $filterSelected = $filteredByGroup.querySelector('.selected-filter');
    let $otherFilters = $filteredByGroup.querySelector('.other-filter');

    if (type === 'resource_status') {
      return;
    }

    if (type === 'dates') {
      currentCount = filteredValue !== '' ? 1 : 0;
    }
    else {
      let $checked = $filteredByGroup.closest('.filters-list').parentNode.querySelectorAll('.sub-filters[data-vid=' + vid + '] input[type=checkbox]:checked, .sub-filters[data-vid=' + vid + '] input[type=radio]:checked');

      $checked = Array.from($checked);

      currentFilters = [];

      $checked.forEach(element => {
        currentFilters.push(element.value);
      });

      currentCount = currentFilters.length;

      currentFilters = currentFilters.join(' ');
    }

    $filteredByGroup.setAttribute('data-selected-filters', currentFilters);

    $filteredByGroup.setAttribute('data-count', currentCount);

    // Displaying the count or not
    // And handling the submitBtn disabled attribute
    // Based on currentCount value (must be > 0 to display)
    if (currentCount === 0) {
      $filterCount.classList.add('is-empty');

      $filteredByGroup.querySelector('.btn-filter').classList.remove('has-count');

      // Set the count html to empty
      $filterCount.innerHTML = '';
    if ($clearSelection) {
      $clearSelection.style.display = 'none';
    }

    if ($filterSelected) {
      $filterSelected.style.display = 'none';
    }

    if ($otherFilters) {
      $otherFilters.style.display = 'none';
    }
  } else {
      $filterCount.classList.remove('is-empty');

      $filteredByGroup.querySelector('.btn-filter').classList.add('has-count');
      if ($clearSelection) {
        $clearSelection.style.display = 'block';
      }

      if ($filterSelected) {
        $filterSelected.style.display = 'block';
      }

      if ($otherFilters) {
        $otherFilters.style.display = 'block';
      }
      // Updates the count html
      $filterCount.innerHTML = currentCount;
    }
    const innerHeight = $filteredByGroup.querySelector('.filter-content').clientHeight;

    if (innerHeight < 500) {
      $filteredByGroup.querySelector('.wrapper').style.height = innerHeight + 10 + 'px';
    } else {
      $filteredByGroup.querySelector('.wrapper').style.height = '500px';
    }

    this.setHeight(innerHeight);
  }

  handleFiltersPanelPosition(childFilters) {
    let isTabletDown = screen.width < 768;

    if (!isTabletDown) {
      childFilters.forEach(childFilter => {
        childFilter.querySelectorAll('a, button, input').forEach(element => element.setAttribute('tabindex', '0'));
      });
    }

    childFilters.forEach(childFilter => {
      childFilter.classList.add('is-active');
    });
  }

  /**
   * type = id is only used for activites module... not using algolia
   * @param $thisForm
   * @param type
   * @param activeDependencies
   * @returns {*|{}}
   */
  getFilters($thisForm, type = 'name', activeDependencies = {}) {
    this.toggleResearchProjectsButton();

    let activeFilters = {};

    let contentType;

    if ($thisForm.querySelector('input[name="all"]:checked') === null) {
      $thisForm.querySelectorAll('input:checked').forEach($this => {
        let vid = $this.getAttribute('data-vid');

        if (vid === 'content_type') {
          contentType = $this.value;
        }

        if ($this.value === '' || $this.value === 'content_type_all' || $this.getAttribute('name') === 'sort-by') {
          return;
        }

        if (!activeFilters[vid]) {
          activeFilters[vid] = [];
        }

        if (type === 'name') {
          activeFilters[vid].push($this.getAttribute('data-name'));
        }
        else {
          activeFilters[vid].push($this.value);
        }

        if (typeof $this.getAttribute('data-identifier') !== 'undefined') {
          if (!activeDependencies[vid]) {
            activeDependencies[vid] = [];
          }

          activeDependencies[vid].push($this.getAttribute('data-identifier'));
        }
      });

      if (contentType === 'content_type_event' || contentType === 'content_type_news') {
        $thisForm.querySelectorAll('.datepicker').forEach($this => {
          if ($this.value !== '') {
            let dateFilterName = contentType === 'content_type_event' ? 'event_dates' : 'date';

            let dateValue = $this.value.replace(' ', '');

            let values = dateValue.split('-');

            activeFilters[dateFilterName] = [values[0], values[1]];
          }
        });
      }
    }

    return this.buildFormAttributes($thisForm, activeDependencies, activeFilters);
  }

  buildFiltersQuery(activeFilters, baseAlgoliaFilter) {
    let conditions = [];
    let condition;

    for (let key in activeFilters) {
      if (this.dateFields.includes(key)) {
        let startDate = Date.parse(activeFilters[key][0]) / 1000;

        let endDateWithBuffer = ((Date.parse(activeFilters[key][1]) / 1000)) + 86400;

        conditions.push(key + ': ' + (startDate + ' TO ' + endDateWithBuffer));
      }
      else {
        condition = [];

        for (let i = 0; i < activeFilters[key].length; i++) {
          condition.push(key + ':"' + activeFilters[key][i] + '"');
        }

        conditions.push(condition.join(' OR '));
      }
    }

    let query = conditions.length ? '(' + conditions.join(') AND (') + ')' : '';

    if (typeof (baseAlgoliaFilter) !== 'undefined' && baseAlgoliaFilter !== '') {
      if (conditions.length !== 0) {
        query = baseAlgoliaFilter + ' AND ' + query;
      }
      else {
        query = baseAlgoliaFilter;
      }
    }

    return query;
  }

  buildFormAttributes($thisForm, activeDependencies, activeFilters) {
    this.removeFilterAttributes($thisForm);

    for (let vid in activeDependencies) {
      $thisForm.setAttribute('data-filter-' + vid, activeDependencies[vid].join(' '));
    }

    // Uncheck all hidden checkboxes.
    let filtersGroups = Array.from($thisForm.querySelectorAll('li.filters-group'));

    filtersGroups.filter(el => window.getComputedStyle(el).display === 'none').forEach($li => {

      let vid = $li.getAttribute('data-vid'),
        $subFilters = $thisForm.querySelectorAll('div.sub-filters[data-vid=' + vid + ']');

      if ($subFilters !== null) {
        $subFilters.forEach($subFilter => {
          const $checkboxes = $subFilter.querySelectorAll('input:checked');

          if ($checkboxes !== null && $checkboxes.length > 0) {
            $checkboxes.forEach(element => {
              element.checked = false;

              element.dispatchEvent(new Event('change'));
            });

            delete activeFilters[vid];

            this.updateFilterCount($li, '');
          }

          const $datepicker = $subFilter.querySelector('input.datepicker');

          if ($datepicker !== null) {
            $datepicker.value = '';

            delete activeFilters[vid];

            this.updateFilterCount($li, '');
          }
        })
      }
    });

    return activeFilters;
  };

  buildUrlQuery(activeFilters, wrapInQuote = false) {
    let url = [];

    for (let key in activeFilters) {
      if (this.dateFields.includes(key)) {
        url.push(encodeURIComponent(`${Drupal.t('filters')}[${key}]`) + '=' + this.fixedEncodeURI('"' + activeFilters[key][0] + '-' + activeFilters[key][1] + '"'));
      }
      else {
        for (let i = 0; i < activeFilters[key].length; i++) {
          if (wrapInQuote) {
            url.push(encodeURIComponent(`${Drupal.t('filters')}[${key}][]`) + '=' + this.fixedEncodeURI('"' + activeFilters[key][i] + '"'));
          }
          else {
            url.push(encodeURIComponent(`${Drupal.t('filters')}[${key}][]`) + '=' + this.fixedEncodeURI(activeFilters[key][i]));
          }
        }
      }
    }

    return url.join('&');
  };

  /**
   * Remove attributes starting with data-filter
   * @param $form
   */
  removeFilterAttributes($form) {
    if ($form !== null) {
      let attrs = $form.attributes;

      let toRemove = [];

      // remove all data-filter attributes
      for (let attr in attrs) {
        if (typeof attrs[attr] === 'object' && typeof attrs[attr].name === 'string' && (/^data-filter/).test(attrs[attr].name)) {
          // Unfortunately, we can not call removeAttr directly in here, since it
          // hurts the iteration.
          toRemove.push(attrs[attr].name);
        }
      }

      for (let i = 0; i < toRemove.length; i++) {
        $form.setAttribute(toRemove[i], '');
      }
    }
  }

  fixedEncodeURI(input) {
    return encodeURIComponent(input).replace(/%20/g, '+');
  }

  /**
   * Display/Hide search projects button if collections matches some selected checkboxes
   */
  toggleResearchProjectsButton() {
    // 261 = Recherche subventionnée en sciences sociales.
    // 262 = Recherche scientifique subventionnée.
    const ids = [261, 262];

    const collectionsInputs = Array.from(this.DOMEl.querySelectorAll('[data-vid="resource_collection"] input:checked')).map(x => Number(x.value));

    const searchButton = this.DOMEl.querySelector('.search-projects-redirect');

    if (collectionsInputs.some(value => ids.includes(value))) {
      searchButton.classList.remove('hide');
    }
    else {
      searchButton.classList.add('hide');
    }
  }
  clearSelection(ev) {
    console.log(ev.target.parentNode.parentNode);

    ev.preventDefault();

    let parent = ev.target.closest('.sub-filters');

    let $items = parent.querySelectorAll('.sub-filters input[type="checkbox"]:checked');

    $items.forEach(function ($this) {
      $this.checked = false;
    });

    let $li = parent.closest('li');
    let $filterCount = $li.querySelector('.filter-count');

    $li.setAttribute('data-selected-filters', '');

    $li.setAttribute('data-count', 0);

    let btnFilter = $li.querySelector('.btn-filter');

    let $clearSelection = $li.querySelector('.clear-selection');
    let $filterSelected = $li.querySelector('.selected-filter');
    let $otherFilters = $li.querySelector('.other-filter');

    if (btnFilter) {
      btnFilter.classList.remove('has-count');
      if($clearSelection) {
        $clearSelection.style.display = 'none';
      }
      if($filterSelected) {
        $filterSelected.style.display = 'none';
      }
      if($otherFilters) {
        $otherFilters.style.display = 'none';
      }
    }

    if ($filterCount) {
      $filterCount.classList.add('is-empty');
      // $clearSelection.style.display = 'block';
      // $filterSelected.style.display = 'block';
      // $otherFilters.style.display = 'block';

      $filterCount.innerHTML = '';
    }

    let filterContainer = document.querySelector('.filters-container');

    let searchNeeded = false;

    if (parent === null) {
      // Clear search-bar
      let $searchInput = document.querySelector('#q');

      if ($searchInput.value.length > 0) {
        searchNeeded = true;

        $searchInput.value = '';
      }

      // Choose all content types.
      let $contentTypeAll = document.querySelector('#filter-content_type_all-');

      if ($contentTypeAll && !$contentTypeAll.checked) {
        $contentTypeAll.checked = true;

        searchNeeded = true;
      }

      // Reset inputs.
      // let $items = document.querySelectorAll('.sub-filters input[type="checkbox"]:checked');
      //
      // $items.forEach(function ($this) {
      //   searchNeeded = true;
      //
      //   $this.checked = false;
      // });

      // Reset date.

      if (datePickerToReset) {
        for (let idSubFilters in datePickerToReset) {
          let picker = this.datepicker.datePickers[datePickerToReset[idSubFilters]];

          if (typeof (picker) !== 'undefined') {
            picker.clearSelection();
          }
        }
      }

      // Reset filters count to zero and trigger search
      if (searchNeeded) {
        let filtersGroups = Array.from(filterContainer.querySelectorAll('li.filters-group'));

        filtersGroups.filter(el => window.getComputedStyle(el).display !== 'none').forEach($li => {
          let type = $li.getAttribute('data-type');

          if (type !== 'content_type') {
            let $filterCount = $li.querySelector('.filter-count');

            $li.setAttribute('data-selected-filters', '');

            $li.setAttribute('data-count', 0);

            let btnFilter = $li.querySelector('.btn-filter');

            let $clearSelection = $li.querySelector('.clear-selection');
            let $filterSelected = $li.querySelector('.filterSelected');
            let $otherFilters = $li.querySelector('.other-filter');

            if (btnFilter) {
              btnFilter.classList.remove('has-count');
            }
              if($clearSelection) {
                $clearSelection.style.display = 'none';
              }
              if($filterSelected) {
                $filterSelected.style.display = 'none';
              }
              if($otherFilters) {
                $otherFilters.style.display = 'none';
            }

            if ($filterCount) {
              $filterCount.classList.add('is-empty');
              // $clearSelection.style.display = 'block';
              // $filterSelected.style.display = 'block';
              // $otherFilters.style.display = 'block';

              $filterCount.innerHTML = '';
            }
          }
        });

        const contentType = filterContainer.querySelector('.sub-filters[data-type="content_type"] input:checked');

        const event = new CustomEvent('change', {
          detail: {
            customTarget: contentType,
          },
        });

        // Trigger the search
        filterContainer.dispatchEvent(event);
      }
    } else {
      if (parent.getAttribute('data-type') === 'dates') {
        const picker = this.datepicker.datePickers[parent.getAttribute('id')];

        if (typeof picker !== 'undefined') {
          picker.clearSelection();
        }

        const dateInput = parent.querySelector('input.datepicker');

        if (dateInput) {
          dateInput.value = '';

          const event = new CustomEvent('change', {
            detail: {
              customTarget: dateInput,
            },
          });

          // Trigger the search.
          filterContainer.dispatchEvent(event);
        }
      }
    }
    this.DOMEl.querySelectorAll('input:checked').forEach($this => {
      // $this.checked = false;

      $this.dispatchEvent(new Event('change'));
    });

    this.DOMEl.querySelectorAll('.datepicker').forEach($this => {
      $this.value = '';

      $this.dispatchEvent(new Event('change'));
    });

    this.onSubmitFilters(ev, false);
  }
}
